import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  ...props
}: CardProps) {
  return <div className={`bg-navy-800 border border-slate-700/50 rounded-lg shadow-sm ${noPadding ? '' : 'p-6'} ${className}`} {...props} data-id="element-165">
      {children}
    </div>;
}